function parseTokenPayload (token) {
  if (!token) return null
  try {
    const segment = token.split('.')[1]
    if (!segment) return null
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    return JSON.parse(decodeURIComponent(escape(atob(padded))))
  } catch (e) {
    return null
  }
}

/** 从 token 解析当前登录用户的 schoolId */
export function getSchoolIdFromToken (token) {
  const payload = parseTokenPayload(token)
  if (payload && payload.schoolId != null && payload.schoolId !== '') {
    return String(payload.schoolId)
  }
  return null
}

function getSchoolIdFromHref (href) {
  const queryIndex = href.indexOf('?')
  if (queryIndex === -1) return null
  const urlSchoolId = new URLSearchParams(href.slice(queryIndex + 1)).get('schoolId')
  return urlSchoolId != null && urlSchoolId !== '' ? urlSchoolId : null
}

/** 同步 URL / token 到 sessionStorage，schoolId 以 URL 参数为准 */
export function syncSessionAuthFromLocation (href = window.location.href) {
  if (!href) return

  const queryIndex = href.indexOf('?')
  if (queryIndex !== -1) {
    const params = new URLSearchParams(href.slice(queryIndex + 1))

    if (params.get('api') != null) {
      sessionStorage.setItem('api', true)
    }
    if (params.get('appId') != null) {
      sessionStorage.setItem('appId', params.get('appId'))
    }
    if (params.get('token') != null) {
      const arr = params.get('token').split(' ')
      if (arr[1]) {
        sessionStorage.setItem('token', arr[1])
      }
    }
  }

  const urlSchoolId = getSchoolIdFromHref(href)
  if (urlSchoolId) {
    sessionStorage.setItem('schoolId', urlSchoolId)
    return
  }

  const tokenSchoolId = getSchoolIdFromToken(sessionStorage.getItem('token'))
  if (tokenSchoolId) {
    sessionStorage.setItem('schoolId', tokenSchoolId)
  }
}

/** 获取当前应使用的 schoolId：URL > token > sessionStorage */
export function getCurrentSchoolId () {
  const urlSchoolId = getSchoolIdFromHref(window.location.href)
  if (urlSchoolId) {
    return urlSchoolId
  }
  const tokenSchoolId = getSchoolIdFromToken(sessionStorage.getItem('token'))
  if (tokenSchoolId) {
    return tokenSchoolId
  }
  return sessionStorage.getItem('schoolId')
}
